export function normalizeName(name: string): string {
  if (!name) return '';
  return name
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isSameName(a: string, b: string): boolean {
  return normalizeName(a) === normalizeName(b);
}
